export const pieOptions = {
  title: '',
  pieHole: 0.5,
  slices: [
    {
      color: '#2BB673',
    },
    {
      color: '#d91e48',
    },
    {
      color: '#007fad',
    },
    {
      color: '#e9a227',
    },
  ],
  legend: {
    position: 'bottom',
    alignment: 'center',
    textStyle: {
      color: '233238',
      fontSize: 14,
    },
  },
  tooltip: {
    showColorCode: true,
  },
  chartArea: {
    left: 0,
    top: 20,
    width: '100%',
    height: '80%',
  },
  fontName: 'Montserrat',
};

export const ignoreValues = {
  diskUsage: ['all', 'size'],
  memory: ['MemAvailableEnabled', 'Total'],
  cpu: ['Total'],
};
